var MemoryStorage =
/** @class */
function () {
  function MemoryStorage() {
    this.memoryStorage = new Map();
  }

  MemoryStorage.prototype.isEnabled = function () {
    return true;
  };

  MemoryStorage.prototype.get = function (key) {
    return this.memoryStorage.get(key);
  };

  MemoryStorage.prototype.getRaw = function (key) {
    var value = this.get(key);
    return value ? JSON.stringify(value) : undefined;
  };

  MemoryStorage.prototype.set = function (key, value) {
    this.memoryStorage.set(key, value);
  };

  MemoryStorage.prototype.remove = function (key) {
    this.memoryStorage.delete(key);
  };

  MemoryStorage.prototype.reset = function () {
    this.memoryStorage.clear();
  };

  return MemoryStorage;
}();

export { MemoryStorage };